import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { MatDialogComponent } from '../../dialog-box/mat-dialog/mat-dialog.component';

@Component({
  selector: 'app-proceed-reset-pwd',
  templateUrl: './proceed-reset-pwd.component.html',
  styleUrls: ['./proceed-reset-pwd.component.scss']
})
export class ProceedResetPwdComponent implements OnInit {
  uniqueCode: string = ''
  valid: boolean = false;
  maskedEmail: string = ''
  isBeforeExpired: boolean = false
  url:any;
  constructor(private dialog: MatDialog, private router: Router,
    private route: ActivatedRoute, private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.uniqueCode = params['uniqueCode']
    })
    this.route.queryParams.subscribe(params => {
      this.url = params['redirect_url'];
    });
    this.getResetPwdInfo()
  }
  sendResetPwdOTP() {
    this.loader.show()
    let url = 'api/digital/core/ResetPassword/SendResetPasswordOTP'
    let params = {
      "uniqueCode": this.uniqueCode
    }
    this.restService.postUATData(params, url).subscribe({
      next: (data) => {
        if (data.rcode === 200) {
          this.loader.hide();
          this.router.navigate(['/auth/email-otp/' + this.uniqueCode]);
        }
        else {
          this.loader.hide();
          let a = data.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
      error: (error) => {
        if (error.error.rcode != 401 && error.error.rcode != 403
          && error.error.rcode != 404 && error.error.rcode != 500) {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: error.error.trnID, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
    });
  }
  getResetPwdInfo() {
    this.loader.show()
    let url = 'api/digital/core/ResetPassword/GetResetPasswordInfo'
    let params = {
      "uniqueCode": this.uniqueCode
    }
    this.restService.postUATData(params, url).subscribe({
      next: (data) => {
        if (data.rcode === 200) {
          this.loader.hide();
          let resData = data.rObj
          this.maskedEmail = resData.maskedEmail
          this.valid = resData.isValid
          this.isBeforeExpired = resData.isBeforeExpired
        }
        else {
          this.loader.hide();
          let a = data.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: data.rObj.transactionRefNum, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
      error: (error) => {
        if (error.error.rcode != 401 && error.error.rcode != 403
          && error.error.rcode != 404 && error.error.rcode != 500) {
          this.loader.hide();
          let a = error.error.rmsg[0].errorCode ?? 'ERROR'
          let err = this.translate.instant(a)
          const dialogRef = this.dialog.open(MatDialogComponent, {
            panelClass: ['dialog-responsive'],
            disableClose: true,
            data: { error: true, trnID: error.error.trnID, errorMessage: err }
          });
          dialogRef.afterClosed().subscribe();
        }
      },
    });
  }
  goToLogin() {
    if (this.url) {
      const decodedUrl = decodeURIComponent(this.url);
      window.location.href = decodedUrl; // Redirect to the decoded URL
    }
  }
}
